import { client } from '../../../shared-interface';

const terminateTicketSession = (productTicketID: string) => client().post('tickets/' + productTicketID + '/terminate');

const ticketApi = {
  terminateTicketSession,
};

export default ticketApi;
